type StateRecord = {
  CountryCode: string;
  StateCode: string;
  Name: string;
  Code: string;
};

export function getStateOptionsCaliforniaFirst(states: StateRecord[]) {
  const sorted = [
    ...states.filter((s) => s.CountryCode === "US" && s.StateCode === "CA"),
    ...states
      .filter((s) => s.CountryCode === "US" && s.StateCode !== "CA")
      .sort((a, b) => a.Name.localeCompare(b.Name)),
    ...states.filter((s) => s.CountryCode === "MX"),
    ...states.filter((s) => s.CountryCode === "CA"),
  ];

  return sorted.map((x) => ({ Text: x.Name, Value: x.Code }));
}
